import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import "../../../Styles/regionFilter.scss";

export default function RegionFilter({ onCountryChange }) {
  const countries = useSelector(
    (state) => state.getCountries?.countries?.response || []
  );
  const [selectedValues, setSelectedValues] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  const handleSelectAll = () => {
    if (selectedValues.length === countries.length) {
      setSelectedValues([]);
      onCountryChange("");
    } else {
      const allValues = countries.map((country) => country.name);
      setSelectedValues(allValues);
      onCountryChange(allValues.join(", "));
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValues(value);
    onCountryChange(value.join(", "));
  };

  const filteredValues = countries.filter((country) =>
    country.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Grid item xs={12} sm={6} md={4} className="gridFilterStyle">
      <div
        className="filterRegion"
        onMouseDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <FormControl
          fullWidth
          size="small"
          className="formControl"
          style={{ backgroundColor: "white" }}
        >
          <Select
            multiple
            value={selectedValues}
            onChange={handleChange}
            displayEmpty
            onOpen={() => {
              setTimeout(() => searchInputRef.current?.focus(), 100);
            }}
            renderValue={(selected) => {
              if (selected.length === 0) return <span style={{ fontStyle: "inter" }}>Country</span>;
              if (selected.length <= 2) return selected.join(", ");
              return `${selected.slice(0, 1).join(", ")}... (${selected.length})`;
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 400,
                  overflowY: "auto",
                  width: "350px",
                  backgroundColor: "white",
                },
              },
              MenuListProps: {
                style: {
                  padding: 0,
                  width: "350px",
                },
              },
            }}
          >
            {/* Search Input */}
            <MenuItem disableRipple style={{ display: "block" }}>
              <div
                className="search"
                onMouseDown={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                <TextField
                  inputRef={searchInputRef}
                  value={searchQuery}
                  size="small"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  placeholder="Search..."
                  style={{
                    width: "320px",
                    marginBottom: "8px",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </MenuItem>

            {/* Select All */}
            <MenuItem value="selectAll">
              <Checkbox
                checked={selectedValues.length === countries.length}
                indeterminate={
                  selectedValues.length > 0 &&
                  selectedValues.length < countries.length
                }
                onChange={handleSelectAll}
              />
              <ListItemText primary="Select All" />
            </MenuItem>

            {/* Country List */}
            {filteredValues.length > 0 ? (
              filteredValues.map((country) => (
                <MenuItem key={country.name} value={country.name}>
                  <Checkbox checked={selectedValues.includes(country.name)} />
                  <ListItemText primary={country.name} />
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                <ListItemText primary="No results found" />
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </div>
    </Grid>
  );
}
